module.exports = __webpack_public_path__ + "static/media/faq.b96eb91a.svg";